/** PRODUCTS */
export const ADD_PRODUCT_START = "ADD_PRODUCT_START";
export const ADD_PRODUCT_SUCCESS = "ADD_PRODUCT_SUCCESS";
export const ADD_PRODUCT_FAIL = "ADD_PRODUCT_FAIL";

export const SINGLE_PRODUCT_INIT = "SINGLE_PRODUCT_INIT";
export const SINGLE_PRODUCT_STORE = "SINGLE_PRODUCT_STORE";

export const DELETE_PRODUCT_START = "DELETE_PRODUCT_START";
export const DELETE_PRODUCT_SUCCESS = "DELETE_PRODUCT_SUCCESS";
export const DELETE_PRODUCT_FAIL = "DELETE_PRODUCT_FAIL";

export const UPDATE_PRODUCT_START = "UPDATE_PRODUCT_START";
export const UPDATE_PRODUCT_SUCCESS = "UPDATE_PRODUCT_SUCCESS";
export const UPDATE_PRODUCT_FAIL = "UPDATE_PRODUCT_FAIL";

export const FETCH_ALL_PRODUCTS_START = "FETCH_ALL_PRODUCTS_START";
export const FETCH_ALL_PRODUCTS_SUCCESS = "FETCH_ALL_PRODUCTS_SUCCESS";
export const FETCH_ALL_PRODUCTS_FAIL = "FETCH_ALL_PRODUCTS_FAIL";

export const FETCH_MAIN_PRODUCTS_START = "FETCH_MAIN_PRODUCTS_START";
export const FETCH_MAIN_PRODUCTS_SUCCESS = "FETCH_MAIN_PRODUCTS_SUCCESS";
export const FETCH_MAIN_PRODUCTS_FAIL = "FETCH_MAIN_PRODUCTS_FAIL";

export const FETCH_SUB_PRODUCTS_START = "FETCH_SUB_PRODUCTS_START";
export const FETCH_SUB_PRODUCTS_SUCCESS = "FETCH_SUB_PRODUCTS_SUCCESS";
export const FETCH_SUB_PRODUCTS_FAIL = "FETCH_SUB_PRODUCTS_FAIL";

export const SEARCH_PRODUCT_BY_NAME_START = "SEARCH_PRODUCT_BY_NAME_START";
export const SEARCH_PRODUCT_BY_NAME_SUCCESS = "SEARCH_PRODUCT_BY_NAME_SUCCESS";
export const SEARCH_PRODUCT_BY_NAME_FAIL = "SEARCH_PRODUCT_BY_NAME_FAIL";

/** LOGIN */
export const USER_LOGIN_START = "USER_LOGIN_START";
export const USER_LOGIN_SUCCESS = "USER_LOGIN_SUCCESS";
export const USER_LOGIN_FAIL = "USER_LOGIN_FAIL";
export const USER_LOGOUT = "USER_LOGOUT";

/** BUYER */
export const FETCH_ALL_BUYERS_START = "FETCH_ALL_BUYERS_START";
export const FETCH_ALL_BUYERS_SUCCESS = "FETCH_ALL_BUYERS_SUCCESS";
export const FETCH_ALL_BUYERS_FAIL = "FETCH_ALL_BUYERS_FAIL";

export const SEARCH_BUYER_EMAIL_START = "SEARCH_BUYER_EMAIL_START";
export const SEARCH_BUYER_EMAIL_SUCCESS = "SEARCH_BUYER_EMAIL_SUCCESS";
export const SEARCH_BUYER_EMAIL_FAIL = "SEARCH_BUYER_EMAIL_FAIL";

/*  orders */
export const FETCH_ORDERS_START = "FETCH_ORDERS_START";
export const FETCH_ORDERS_SUCCESS = "FETCH_ORDERS_SUCCESS";
export const FETCH_ORDERS_FAIL = "FETCH_ORDERS_FAIL";

export const FETCH_ORDERS_BY_ID_START = "FETCH_ORDERS_BY_ID_START";
export const FETCH_ORDERS_BY_ID_SUCCESS = "FETCH_ORDERS_BY_ID_SUCCESS";
export const FETCH_ORDERS_BY_ID_FAIL = "FETCH_ORDERS_BY_ID_FAIL";

export const FETCH_NEW_ORDER_START = "FETCH_NEW_ORDER_START";
export const FETCH_NEW_ORDER_SUCCESS = "FETCH_NEW_ORDER_SUCCESS";
export const FETCH_NEW_ORDER_FAIL = "FETCH_NEW_ORDER_FAIL";

export const FETCH_ONWAY_ORDER_START = "FETCH_ONWAY_ORDER_START";
export const FETCH_ONWAY_ORDER_SUCCESS = "FETCH_ONWAY_ORDER_SUCCESS";
export const FETCH_ONWAY_ORDER_FAIL = "FETCH_ONWAY_ORDER_FAIL";

export const FETCH_REJECT_ORDER_START = "FETCH_REJECT_ORDER_START";
export const FETCH_REJECT_ORDER_SUCCESS = "FETCH_REJECT_ORDER_SUCCESS";
export const FETCH_REJECT_ORDER_FAIL = "FETCH_REJECT_ORDER_FAIL";

export const FETCH_DELIVERD_ORDER_START = "FETCH_DELIVERD_ORDER_START";
export const FETCH_DELIVERD_ORDER_SUCCESS = "FETCH_DELIVERD_ORDER_SUCCESS";
export const FETCH_DELIVERD_ORDER_FAIL = "FETCH_DELIVERD_ORDER_FAIL";

export const REJECT_ORDER_START = "REJECT_ORDER_START";
export const REJECT_ORDER_SUCCESS = "REJECT_ORDER_SUCCESS";
export const REJECT_ORDER_FAIL = "REJECT_ORDER_FAIL";

export const ONWAY_ORDER_START = "ONWAY_ORDER_START";
export const ONWAY_ORDER_SUCCESS = "ONWAY_ORDER_SUCCESS";
export const ONWAY_ORDER_FAIL = "ONWAY_ORDER_FAIL";

export const DELIVERD_ORDER_START = "DELIVERD_ORDER_START";
export const DELIVERD_ORDER_SUCCESS = "DELIVERD_ORDER_SUCCESS";
export const DELIVERD_ORDER_FAIL = "DELIVERD_ORDER_FAIL";

/** DASHBOARD */
export const FETCH_DASHBOARD_START = "FETCH_DASHBOARD_START";
export const FETCH_DASHBOARD_SUCCESS = "FETCH_DASHBOARD_SUCCESS";
export const FETCH_DASHBOARD_FAIL = "FETCH_DASHBOARD_FAIL";
